import { timelineItems } from '@/mocks/homeData';

export default function TimelineFeed() {
  return (
    <section id="timeline" className="w-full border-t border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto grid w-full max-w-[1360px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-[1fr_320px] lg:gap-10">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
            Timeline
          </span>
          <h2 className="mt-2 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
            准点时间线 · 顺着往下读
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            从午后到 18:00，黑料六点每日准点把每条进展按时间挂上，先给结论，再给线索来源，方便一条线读到底。
          </p>

          <ol className="relative mt-6 border-l border-background-300 pl-5 md:pl-7">
            {timelineItems.map((item, index) => (
              <li key={item.time} className="relative pb-6 last:pb-0">
                <span
                  className={`absolute -left-[27px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-50 md:-left-[35px] ${
                    index === 0 ? 'bg-primary-500' : 'bg-background-400'
                  }`}
                />
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`font-heading text-sm font-black ${
                      index === 0 ? 'text-primary-600' : 'text-foreground-900'
                    }`}
                  >
                    {item.time}
                  </span>
                  <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[11px] font-semibold text-secondary-800">
                    {item.tag}
                  </span>
                  {index === 0 && (
                    <span className="flex items-center gap-1 rounded-sm bg-primary-100 px-1.5 py-0.5 text-[11px] font-semibold text-primary-700">
                      <span className="pulse-dot flex h-1.5 w-1.5 rounded-full bg-primary-500" />
                      最新
                    </span>
                  )}
                </div>
                <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm" />
                    {item.comments}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-sm text-primary-500" />
                    {item.heat}
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:sticky lg:top-24 lg:self-start">
          <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-timer-flash-line text-lg" />
              </span>
              <div>
                <p className="font-heading text-sm font-black text-foreground-950">下一波准点</p>
                <p className="text-xs text-foreground-600">黑料六点每日定时</p>
              </div>
            </div>
            <div className="mt-4 flex items-end gap-1.5">
              {['01', ':', '12', ':', '36'].map((seg, i) => (
                <span
                  key={`${seg}-${i}`}
                  className={`font-heading text-2xl font-black tabular-nums text-accent-800 ${
                    seg === ':' ? 'pb-1 text-accent-600' : ''
                  }`}
                >
                  {seg}
                </span>
              ))}
            </div>
            <p className="mt-3 text-xs leading-relaxed text-foreground-600">
              到点后首页会自动把新条目排到最前，也可以先订阅提醒，到点再看。
            </p>
            <a
              href="#subscribe"
              className="mt-4 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
            >
              <i className="ri-notification-3-line" />
              订阅准点提醒
            </a>
          </div>

          <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-5">
            <p className="font-heading text-sm font-black text-foreground-950">节奏说明</p>
            <ul className="mt-3 space-y-3">
              {[
                { icon: 'ri-sun-line', text: '午后到傍晚，零散线索实时进池' },
                { icon: 'ri-archive-2-line', text: '18:00 准点归档，重排时间线' },
                { icon: 'ri-chat-smile-2-line', text: '评论区持续补充，线索留在楼层里' },
              ].map((row) => (
                <li key={row.text} className="flex items-start gap-2.5">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-200 text-foreground-700">
                    <i className={`${row.icon} text-sm`} />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{row.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}